const zhCN = {
  boardTitle: '园区出入口大数据平台',

  personnelUnit: '人',
  tenThousand: '万',
  today: '今日',
  yesterday: '昨日',
  thisMonth: '本月',
  lastMonth: '上月',
  oClock: '时',
  day: '号',

  registeredTxt: '在册用户',
  registeredUnit: '人',
  registeredAuthed: '有权限',
  registeredUnauthed: '无权限',
  
  dailyTrafficTxt: '今日人员',
  dailyVisitorTxt: '今日访客',

  trafficUnit: '人',
  trafficEnter: '进入',
  trafficExit: '出门',

  warningTxt: '今日预警',
  warningUnit: '人',
  warningStranger: '陌生人',
  warningBlacklist: '黑名单',

  deviceTxt: '设备',
  deviceUnit: '台',
  deviceOnline: '在线',
  deviceOffline: '离线',

  visitorInfoTitle: '访客信息',
  registeredInfoTitle: '人员信息',
  infoEntryTxt: '进门',
  infoExitTxt: '出门',
  infoChannelTxt: '通道',
  infoTimeTxt: '时间',
  infoVisitTxt: '来访事由',

  visitorEntryExitTitle: '访客进出',
  registeredEntryExitTitle: '人员进出',

  entryBtn: '进入',
  exitBtn: '离开',
  dailyBtn: '天',
  monthlyBtn: '月'
}
const enUS = {
  boardTitle: 'Intelligent ACS Dashboard',

  personnelUnit: 'man',
  tenThousand: 'W',
  today: 'Today',
  yesterday: 'Yesterday',
  thisMonth: 'This Month',
  lastMonth: 'Last Month',
  oClock: 'o\'clock',
  day: 'th',

  registeredTxt: 'Registered',
  registeredUnit: '',
  registeredAuthed: 'Authed',
  registeredUnauthed: 'Unauthed',

  dailyTrafficTxt: 'Daily Traffic',
  dailyVisitorTxt: 'Daily Visitor',

  trafficUnit: '',
  trafficEnter: 'Enter',
  trafficExit: 'Exit',

  warningTxt: 'Warning',
  warningUnit: '',
  warningStranger: 'Stranger',
  warningBlacklist: 'Blacklist',

  deviceTxt: 'Device',
  deviceUnit: '',
  deviceOnline: 'Online',
  deviceOffline: 'Offline',

  visitorInfoTitle: 'Visitor Info',
  registeredInfoTitle: 'Registered Info',
  infoEntryTxt: 'Entry',
  infoExitTxt: 'Exit',
  infoChannelTxt: 'Channel',
  infoTimeTxt: 'Time',
  infoVisitTxt: 'Visit',

  visitorEntryExitTitle: 'Visitor Entry-exit',
  registeredEntryExitTitle: 'Registered Entry-exit',

  entryBtn: 'Entry',
  exitBtn: 'Exit',
  dailyBtn: 'Daily',
  monthlyBtn: 'Monthly'
}

export default { zhCN, enUS }